import { PayloadAction } from '@reduxjs/toolkit';
import { AppBundle } from 'api/optimalprint-sdk.d';
import { StudioSearchState } from 'store/studioSearch/types';

type SetStudioSearchResultsPayload = {
  searchResults: any;
  filters: AppBundle.Api.Response.Category.V3.CategoryDesignsListV3Response.Filters;
  pageNr: number;
  totalResultsAvailable: number;
};
const setStudioSearchResultsReducer = (
  state: StudioSearchState,
  action: PayloadAction<SetStudioSearchResultsPayload>,
) => {
  const insertBefore = action.payload.pageNr < state.minPage;
  if (insertBefore) {
    state.searchResults = [...action.payload.searchResults, ...state.searchResults];
  } else {
    state.searchResults.push(...action.payload.searchResults);
  }
  state.filters = action.payload.filters;
  state.minPage = Math.min(state.minPage, action.payload.pageNr);
  state.maxPage = Math.max(state.maxPage, action.payload.pageNr);
  state.pageNr = action.payload.pageNr;
  state.totalResultsAvailable = action.payload.totalResultsAvailable;
};

export default setStudioSearchResultsReducer;
